import React from 'react';

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {Moment} from 'moment';

import {EAnalyticsDateRange} from './analyticsTypes';

type AnalyticsFiltersProps = {
  dateRangeId: EAnalyticsDateRange;
  startDate: Moment | null | undefined;
  endDate: Moment | null | undefined;
  onDateRangeChange: (dateRange: EAnalyticsDateRange) => void;
  onStartDateChange: (date: Moment | null) => void;
  onEndDateChange: (date: Moment | null) => void;
};

export function AnalyticsFilters(props: AnalyticsFiltersProps) {
  const handleDateRangeChange = (
    event: React.ChangeEvent<{name?: string; value: unknown}>,
  ) => {
    props.onDateRangeChange(event.target.value as EAnalyticsDateRange);
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Grid container spacing={1} className="analytics-filter-row">
        <Grid item xs={12} sm={4} md={3}>
          <FormControl
            className="analytics-filter-control date-range-select"
            variant="outlined"
            fullWidth
          >
            <InputLabel id="date-range-select-label">Date Range</InputLabel>
            <Select
              labelId="date-range-select-label"
              id="date-range-select"
              label="Date Range"
              value={props.dateRangeId}
              onChange={handleDateRangeChange}
              fullWidth
            >
              <MenuItem value={EAnalyticsDateRange.NONE}>
                Select Date Range
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.CUSTOM}>
                Custom Date Range
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.TODAY}>Today</MenuItem>
              <MenuItem value={EAnalyticsDateRange.THIS_WEEK}>
                This Week
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.THIS_MONTH}>
                This Month
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.THIS_YEAR}>
                This Year
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.LAST_7_DAYS}>
                Last 7 Days
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.LAST_30_DAYS}>
                Last 30 Days
              </MenuItem>
              <MenuItem value={EAnalyticsDateRange.ALL_TIME}>All Time</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            inputVariant="outlined"
            label="Start Date"
            format="DD/MM/yyyy"
            value={props.startDate}
            onChange={props.onStartDateChange}
            className="analytics-filter-control date-picker"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            inputVariant="outlined"
            label="End Date"
            format="DD/MM/yyyy"
            value={props.endDate}
            onChange={props.onEndDateChange}
            className="analytics-filter-control date-picker"
            fullWidth
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
